// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_u6-0";
export var checkoutRateBadgeLink = "_u6-1";